import { ref, reactive, watch, type Ref } from 'vue';
import type { ApiV1 } from '@teamworksdev/influencer/core';

interface UseTaskDrawerState {
	isOpen: boolean;
	activeTaskUuid: string | undefined;
	activeListTask: ApiV1.ListTask | undefined;
	onUpdated: (() => void) | undefined;
}

interface UseTaskDrawerReturn {
	state: UseTaskDrawerState;
	isRendered: Ref<boolean>;
	resetState: () => void;
	open: (uuid: string, listTask: ApiV1.ListTask) => void;
	close: () => void;
}

const DEFAULT_STATE: UseTaskDrawerState = {
	isOpen: false,
	activeTaskUuid: undefined,
	activeListTask: undefined,
	onUpdated: undefined,
} as const;

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseTaskDrawerState>(getDefaultState());

function resetState() {
	Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
	if (isOpen && !isRendered.value) isRendered.value = true;
	if (!isOpen) resetState();
});

interface UseTaskDrawerOptions {
	onUpdated?: () => void;
}

export function useTaskDrawer(options?: UseTaskDrawerOptions): UseTaskDrawerReturn {
	function open(uuid: string, listTask: ApiV1.ListTask) {
		state.isOpen = true;
		state.activeTaskUuid = uuid;
		state.activeListTask = listTask;
		state.onUpdated = options?.onUpdated;
	}

	function close() {
		state.isOpen = false;
	}

	return {
		state,
		isRendered,
		resetState,
		open,
		close,
	};
}

